import { onDomReady } from '../utils/dom';

function addAnimateInClasses() {
    const items = document.querySelectorAll('#main .mod_article .content-wrapper > *:not(.no-animate-in)');

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('animate-in');
                    observer.unobserve(entry.target); // fire once
                }
            });
        },
        { rootMargin: '0px 0px -200px 0px', threshold: 0 },
    );

    items.forEach((item) => observer.observe(item));
}

onDomReady(() => {
    addAnimateInClasses();
});
